module.exports = __webpack_public_path__ + "static/media/Union.776b4442.svg";